module.exports = __webpack_public_path__ + "img/red-alert-icon.166fe077.svg";